<template>
  <div class="crewHome">
    <div class="crewHome-content">
      <el-form :inline="true" :model="formInline" class="other-form-inline">
        <!-- <el-form-item class="flex-form">
          <el-date-picker
            class="hide-icon"
            type="date"
            placeholder="开始时间"
            v-model="formInline.date1"
            style="width: 100px"
          ></el-date-picker>
          <span class="line" style="margin: 0 3px">-</span>
          <el-date-picker
            class="hide-icon"
            placeholder="结束时间"
            v-model="formInline.date2"
            style="width: 100px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="formInline.region"
            placeholder="是否加入人才储备"
            style="width: 165px"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-input
            v-model="formInline.userName"
            placeholder="搜索姓名"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="other-search" @click="onSubmit">
            <i class="el-icon-search"></i>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="other-search" style="width: 100px" @click="inviteAdd()">
            <i class="iconfont icon-yaoqing"></i
            ><span style="font-size: 14px">邀请船员</span>
          </div>
        </el-form-item>
      </el-form>
      <div style="clear: both"></div>
      <el-divider class="other-divider"></el-divider>
      <div class="other-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column prop="userName" label="姓名" min-width="100">
          </el-table-column>
          <el-table-column prop="loginName" label="登录名" min-width="180">
          </el-table-column>
          <el-table-column prop="sex" label="性别" min-width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.sex == '0'">男</span>
              <span v-if="scope.row.sex == '1'">女</span>
            </template>
          </el-table-column>
          <el-table-column prop="idCardNo" label="身份证号" min-width="140">
          </el-table-column>
          <el-table-column prop="cellphoneNo" label="联系方式" min-width="120">
          </el-table-column>
          <!-- <el-table-column prop="date5" label="简历填写进度" min-width="100">
          </el-table-column> -->
          <!-- <el-table-column
            prop="date6"
            label="是否加入人才储备"
            min-width="120"
          >
          </el-table-column> -->
          <el-table-column prop="inviteTime" label="邀请时间" min-width="100">
          </el-table-column>
          <el-table-column label="操作" min-width="210">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="other-watch"
                @click="comDetail(scope)"
              >
                查看
              </el-button>

              <el-button
                type="text"
                size="small"
                class="other-green"
                @click="passInvite(scope)"
              >
                通过
              </el-button>
              <el-button
                type="text"
                size="small"
                class="other-del"
                @click="delInvite(scope)"
              >
                淘汰
              </el-button>
              <el-button type="text" size="small" class="other-watch"  @click="resetPass(scope.row)">
                重置密码
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div class="other-block">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage1"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      class="other-dialog"
      width="450px"
      title="审核通过"
      :visible.sync="companyVisible"
      ref="vueRef"
      :before-close="handleClose"
    >
      <el-form
        label-width="120px"
        :model="formLabelAlign"
        class="other-form"
        :rules="rules"
      >
        <el-form-item label="所属劳务公司" prop="userState">
          <el-select
            v-model="jobParams.userState"
            placeholder="所属劳务公司"
            :remote-method="remoteMethod"
          >
            <el-option label="本劳务公司" value="1"> </el-option>
            <el-option label="其他劳务公司" value="2"> </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="船员类型" prop="crewType">
          <el-select
            v-model="jobParams.crewType"
            placeholder="招聘职位"
            style="width: 135px"
          >
            <el-option label="自有船员" value="1"> </el-option>
            <el-option label="借调船员" value="2"> </el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="other-footer">
        <el-button @click="companyVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="rememendCrewPass()"
          :loading="remendLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getCrewInfo, crewAudit,resetPasswordByIdCardNo } from "@/apis/index";
export default {
  data() {
    return {
      formInline: {},
      tableData: [],
      currentPage1: 1,
      pageNo: "1",
      total: 0,
      pageSize: 10,
      companyVisible: false,
      jobParams: {},
      remendLoading: false,
      diaList: {},
      rules: {
        userState: [
          {
            required: true,
            message: "请选择员工在本派遣机构状态",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getCrewInfoList();
  },
  methods: {
    onSubmit() {
      this.pageNo = 1;
      this.getCrewInfoList();
    },
    handleOpen() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCrewInfoList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getCrewInfoList();
      // console.log(`当前页: ${val}`);
    },
    choseCom() {
      this.companyVisible = true;
    },
    handleClose() {
      this.companyVisible = false;
    },
    comDetail(item) {
      console.log(item);
      this.$router.push({
        name: "inviteDetail",
        params: {
          name: item.row.userName,
          userId: item.row.userId,
          passFlag: "1",
          agentCyAuditId: item.row.agentCyAuditId,
        },
      });
    },
    inviteAdd() {
      this.$router.push({ name: "inviteAdd", params: { name: "邀请投递" } });
    },
    async getCrewInfoList() {
      let res = await getCrewInfo({
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        userOrigin: "2",
        agentAuditState: "1",
        ...this.formInline,
      });
      this.total = res.data.rowCount;
      this.tableData = res.data.resultList;
      this.tableData.forEach((item) => {
        if (item.inviteTime) {
          item.inviteTime = item.inviteTime.split(" ")[0];
        }
      });
    },

    delInvite(scope) {
      this.$confirm("确定要淘汰吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.delList(scope.row);
          // console.log(scope);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async delList(row) {
      await crewAudit({
        agentAuditState: "3",
        userId: row.userId,
        agentCyAuditId: row.agentCyAuditId,
        userOrigin: "2",
      });
      // console.log(res);
      this.getCrewInfoList();
    },
    passInvite(scope) {
      this.jobParams = {};
      this.diaList = scope.row;
      this.companyVisible = true;
    },
    rememendCrewPass() {
      if (!this.jobParams.userState) {
        this.$message({
          message: "请选择是否属于本公司",
          type: "error",
        });
        return;
      }
      this.remendLoading = true;
      this.addCrewList();
    },
    async addCrewList() {
      let res = await crewAudit({
        userState: this.jobParams.userState,
        crewType: this.jobParams.crewType,
        agentAuditState: "2",
        userId: this.diaList.userId,
        agentCyAuditId: this.diaList.agentCyAuditId,
        userOrigin: "2",
      });
      if (res.code == 1) {
        this.$message({
          message: "成功",
          type: "success",
        });
        this.remendLoading = false;
        this.companyVisible = false;
        this.getCrewInfoList();
        // this.$router.push({ name: "邀请船员" });
      } else {
        this.$message({
          message: res.msg,
          type: "warning",
        });
        this.remendLoading = false;
        this.companyVisible = false;
      }
      // console.log(res);
    },
        resetPass(scope) {
      let tips = `是否将 ${scope.userName} 重置密码为船员身份证后8位吗？`
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.resetList(scope);
          // console.log(scope);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async resetList(row) {
      await resetPasswordByIdCardNo({
        userId: row.userId
      });
      this.$message({
        message: "重置成功",
        type: "success",
      });
    },
  },
};
</script>
